import { useMemo } from 'react';
import { useGetPaymentMethodsQuery, useGetPaymentMethodsV2Query } from '~/services/member';

export function useMemberPaymentMethods({
  locationId,
  memberId,
  isDea,
}: {
  locationId: number;
  memberId: number | undefined;
  isDea?: boolean;
}) {
  const { data: rawPaymentMethodsData, refetch: refetchPaymentMethod } = isDea
    ? useGetPaymentMethodsV2Query({
        locationId,
        memberId,
      })
    : useGetPaymentMethodsQuery({
        locationId,
        memberId,
      });

  const paymentMethods = useMemo(
    () =>
      (rawPaymentMethodsData ?? [])
        .filter((raw) => !raw.inactive && !raw.payrix_onboarding_error)
        .map((raw) => ({
          id: raw.id,
          payment_method_id: raw.id,
          type: raw.method < 8 ? 'cc' : 'ach',
          number:
            raw.last_4_digits_card || raw.last_4_digits_account
              ? '**** ' + (raw.last_4_digits_card || raw.last_4_digits_account || '')
              : '',
          description:
            raw.last_4_digits_card || raw.last_4_digits_account
              ? 'Ending in ' + (raw.last_4_digits_card || raw.last_4_digits_account || '')
              : 'ACH Credit Transfer',
          expiration: raw.expiration,

          is_primary: raw.default,
          inactive: raw.inactive,
          error: raw.payrix_onboarding_error,
          pending: raw.payrix_onboarding_status === 98,
          ready: raw.payrix_onboarding_status === 3,
          default: raw.default,
        }))
        .sort((a: any, b: any) => {
          if (a.is_primary) return -1;
          if (b.is_primary) return 1;
          return 0;
        }),
    [rawPaymentMethodsData],
  );

  return { paymentMethods, refetchPaymentMethod };
}
